<template>
  <div class="checkout">
    <v-form
      ref="form"
      class="mb-5"
      @submit.prevent="navigateToConfirmation"
      id="payment-form"
    >
      <v-container class="pt-0 pt-md-3">
        <v-row class="pt-5 d-none d-md-block">
          <breadcrumbs :breadcrumbs="breadcrumbs" />
        </v-row>
        <v-row>
          <v-col cols="12" class="pa-0 pa-md-3">
            <v-stepper alt-labels v-model="step">
              <v-stepper-header>
                <v-stepper-step step="1" color="appGreen" complete
                  >MY BASKET</v-stepper-step
                >

                <v-divider class="active"></v-divider>

                <v-stepper-step step="2" color="appGreen"
                  >DELIVERY & PAYMENT</v-stepper-step
                >

                <v-divider></v-divider>

                <v-stepper-step step="3" color="appGreen"
                  >THANK YOU</v-stepper-step
                >
              </v-stepper-header>
            </v-stepper>
          </v-col>
        </v-row>
        <v-row class="checkout-panel">
          <v-col
            cols="12"
            offset-md="1"
            sm="3"
            class="right-panel d-block d-md-none pb-0"
          >
            <div class="right-panel-container top" :class="{ 'pb-0': !expand }">
              <h2 @click="expand = !expand">
                Your Order Summary
                <span class="expand-icon">
                  <v-icon>mdi-chevron-up</v-icon>
                </span>
              </h2>
              <template v-if="expand">
                <div
                  v-for="product in basket_products"
                  :key="product.id"
                  class="d-flex"
                >
                  <p class="col-8 pa-0">
                    {{ product.quantity }} x {{ product.name }}
                  </p>
                  <p class="col-4 pa-0 text-right">
                    £{{ product.amount * product.quantity }}
                  </p>
                </div>
                <v-divider horizontal></v-divider>
                <div>
                  <p>Sub Total</p>
                  <p>£{{ basketSubTotal }}</p>
                </div>
                <div>
                  <p>Shipping</p>
                  <p>£{{ basketShippingFee }}</p>
                </div>
                <div>
                  <p>Discount</p>
                  <p>£{{ basketDiscount }}</p>
                </div>
                <v-divider horizontal></v-divider>
                <div class="total">
                  <p>Total</p>
                  <p>£{{ basketTotal }}</p>
                </div>
              </template>
            </div>
          </v-col>
          <v-col cols="12" sm="8" class="left-panel">
            <v-row>
              <v-col md="10" cols="12" offset-md="1" class="col">
                <v-row>
                  <div class="d-flex justify-space-between align-center w-100">
                    <div class="flex border-underscore d-block d-md-none"></div>
                    <h2 class="mb-md-3 pt-md-3 px-2 px-md-0 border-label">
                      Contact Information
                    </h2>
                    <div class="flex border-underscore d-block d-md-none"></div>
                  </div>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="user.email"
                          :rules="userRules.email"
                          disabled
                          label="Email Address"
                          solo
                          dense
                          hide-details="auto"
                          flat
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-tel-field
                          label="Phone Number"
                          outlined
                          v-model="user.phone"
                          :rules="userRules.phoneRules"
                          hide-details="auto"
                        ></v-tel-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="my-3 d-none d-md-block">
                    <v-divider horizontal></v-divider>
                  </v-col>
                  <div class="d-flex justify-space-between align-center w-100">
                    <div class="flex border-underscore d-block d-md-none"></div>
                    <h2 class="mb-md-3 pt-md-3 px-2 px-md-0 border-label">
                      Shipping Addresses
                    </h2>
                    <div class="flex border-underscore d-block d-md-none"></div>
                  </div>
                  <v-col cols="12">
                    <v-row>
                      <v-col
                        class="py-0 d-flex justify-space-between"
                        v-if="addresses.length > 0"
                      >
                        <v-radio-group
                          class="mt-0"
                          v-model="userAddress.addressId"
                          :value="addresses[0].id"
                          :rules="userAddressRules"
                        >
                          <template v-for="address in approvedAddresses">
                            <v-radio
                              :key="address.id"
                              :label="address | formattedAddress"
                              :value="address.id"
                              v-if="address.label !== ''"
                            ></v-radio>
                          </template>
                        </v-radio-group>
                        <div></div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="my-3 d-none d-md-block">
                    <v-divider horizontal></v-divider>
                  </v-col>
                  <div class="d-flex justify-space-between align-center w-100">
                    <div class="flex border-underscore d-block d-md-none"></div>
                    <h2 class="mb-md-3 pt-md-3 px-2 px-md-0 border-label">
                      Billing Address
                    </h2>
                    <div class="flex border-underscore d-block d-md-none"></div>
                  </div>
                  <v-col cols="12">
                    <v-row>
                      <v-col class="py-0">
                        <div id="card-element">
                          <!--Stripe.js injects the Card Element-->
                        </div>
                        <div class="spinner hidden" id="spinner"></div>
                        <p
                          id="card-error"
                          class="appRed--text"
                          role="alert"
                        ></p>
                        <p class="result-message hidden">
                          Payment succeeded, see the result in your
                          <a href="" target="_blank">Stripe dashboard.</a>
                          Refresh the page to pay again.
                        </p>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="my-3">
                    <v-divider horizontal></v-divider>
                  </v-col>
                  <h2>Do you agree with our terms & conditions?</h2>
                  <v-col cols="12" class="notifications">
                    <v-checkbox
                      v-model="accept"
                      class="mt-0"
                      label="I agree with the terms and conditions"
                      hide-details="auto"
                      color="black"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            offset-md="1"
            sm="3"
            class="right-panel d-none d-md-block"
          >
            <div class="right-panel-container">
              <h2>Your Order Summary</h2>
              <div
                v-for="product in basket_products"
                :key="product.id"
                class="d-flex"
              >
                <p class="col-8 pa-0">
                  {{ product.quantity }} x {{ product.name }}
                </p>
                <p class="col-4 pa-0 text-right">
                  £{{ product.amount * product.quantity }}
                </p>
              </div>
              <v-divider horizontal></v-divider>
              <div>
                <p>Sub Total</p>
                <p>£{{ basketSubTotal }}</p>
              </div>
              <div>
                <p>Shipping</p>
                <p>£{{ basketShippingFee }}</p>
              </div>
              <div>
                <p>Discount</p>
                <p>£{{ basketDiscount }}</p>
              </div>
              <v-divider horizontal></v-divider>
              <div class="total">
                <p>Total</p>
                <p>£{{ basketTotal }}</p>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="order">
          <v-col cols="8">
            <v-row>
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                :disabled="!accept"
                color="appRed"
                class="white--text"
                >Complete Order</v-btn
              >
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-container fluid class="pa-0">
      <home-footer class="d-none d-md-block" />
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Breadcrumbs from "@/components/Shared/Breadcrumbs/Breadcrumbs.vue";
import HomeFooter from "@/components/Shared/HomeFooter/HomeFooter.vue";
import { loadStripe } from "@stripe/stripe-js";
export default {
  name: "CheckoutComponent",
  components: {
    Breadcrumbs,
    HomeFooter
  },
  filters: {
    formattedAddress: function(address) {
      return `${address.aptNo} ${address.address}, ${address.city}, ${address.postcode}, ${address.country.name}`;
    }
  },
  data: () => ({
    expand: true,
    stripe: null,
    card: null,
    breadcrumbs: ["ORTHODONTICS", "MY BASKET"],
    accept: false,
    step: 2,
    items: ["Foo", "Bar", "Fizz", "Buzz"],
    userRules: {
      firstName: [
        v => !!v || "First Name is required",
        v => (v && v.length >= 3) || "First Name must be at least 3 characters",
        v =>
          (v && v.length <= 35) ||
          "First Name must be less than than 35 characters"
      ],
      lastName: [
        v => !!v || "First Name is required",
        v => (v && v.length >= 3) || "First Name must be at least 3 characters",
        v =>
          (v && v.length <= 35) ||
          "First Name must be less than than 35 characters"
      ],
      email: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      userPositionId: [v => !!v || "User Position is required"],
      gdcNumber: [
        v => !!v || "GDC Number is required",
        v => (v && v >= 10000000) || "GDC Number must be at least 8 digits",
        v =>
          (v && v <= 1000000000) ||
          "GDC Number must be less than than 10 digits"
      ],
      phoneRules: [
        v => !!v || "Phone is required",
        v => (v && v.length >= 8) || "Phone must be at least 8 characters",
        v => (v && v.length <= 35) || "Phone must be less than 35 characters"
      ]
    },
    userAddressRules: [v => !!v || "Please select at atleast on address"],
    phoneRules: [
      v => !!v || "Phone is required",
      v => (v && v.length >= 8) || "Phone must be at least 8 characters",
      v => (v && v.length <= 35) || "Phone must be less than 35 characters"
    ],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    addressRules: [
      v => !!v || "Address is required",
      v => (v && v.length >= 4) || "Address must be at least 4 characters",
      v =>
        (v && v.length <= 100) ||
        "Address must be less than than 100 characters"
    ],
    cityRules: [
      v => !!v || "City is required",
      v => (v && v.length >= 3) || "City must be at least 3 characters",
      v => (v && v.length <= 35) || "City must be less than than 35 characters"
    ],
    postcodeRules: [
      v => !!v || "Postcode is required",
      v => (v && v.length >= 3) || "Postcode must be at least 3 characters",
      v =>
        (v && v.length <= 10) || "Postcode must be less than than 10 characters"
    ],
    countryRules: [v => !!v || "Country is required"],
    aptNoRules: [v => !!v || "Apt no is required"],
    stateRules: [
      v => !!v || "State is required",
      v => (v && v.length >= 3) || "State must be at least 3 characters",
      v => (v && v.length <= 25) || "State must be less than than 25 characters"
    ]
  }),
  async mounted() {
    if (this.basket_products.length < 1) {
      this.$router.push({ name: "basket" });
    }
    await this.$store.dispatch("user/GET_USER");
    await this.$store.dispatch("user/GET_USER_POSITIONS");
    await this.$store.dispatch("surgery/GET_SURGERY_ADDRESS");
    await this.$store.dispatch("user/GET_USER_ADDRESSES");
    await this.$store.dispatch("country/GET_COUNTRIES");
    let vm = this;
    this.stripe = await loadStripe(
      "pk_test_51Ie3SIE2G8bCTlZgz1WttGewqmjtO2IcTO5CmbTlg01B9iXM3czMGBiFy0hbRco3w27GxKRddTc7HQRupdGb25sx00t8ntJfeB"
    );
    this.$nextTick(() => {
      var elements = vm.stripe.elements();
      var style = {
        base: {
          color: "#32325d",
          fontFamily: "Arial, sans-serif",
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#32325d"
          }
        },
        invalid: {
          fontFamily: "Arial, sans-serif",
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };
      this.card = elements.create("card", { style: style });
      this.card.mount("#card-element");
      console.log(vm.approvedAddresses);
      if(vm.approvedAddresses.length > 0) {
        console.log(vm.approvedAddresses[0].id)
        vm.userAddress.addressId = vm.approvedAddresses[0].id
        vm.$forceUpdate()
      }
    });
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      userPositions: state => state.user.userPositions,
      active: state => state.user.active,
      basket_products: state => state.product.basketProducts,
      addresses: state => state.surgery.addresses,
      userAddress: state => state.surgery.address,
      countries: state => state.country.countries,
      intentSecret: state => state.order.intentSecret,
      order: state => state.order.order,
      approvedAddresses() {
        return this.addresses.filter(i => i.approved);
      }
    }),
    ...mapGetters({
      basketSubTotal: "product/basketSubTotal",
      basketShippingFee: "product/basketShippingFee",
      basketDiscount: "product/basketDiscount",
      basketTotal: "product/basketTotal"
    })
  },
  methods: {
    changeActive(id) {
      this.$store.commit("user/CHANGE_ACTIVE", id);
      this.$forceUpdate();
    },
    async save(address, index) {
      if (this.$refs[index + "-form"][0].validate()) {
        this.$swal({
          title:
            address.id === undefined
              ? "Creating address..."
              : "Updating address",
          html: "this will only take a moment...",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("user/SAVE_ADDRESS", address);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html:
            address.id !== undefined
              ? "Address updated successfully"
              : "Address created successfully",
          icon: "info"
        });
      }
    },
    add() {
      this.$store.commit("user/PUSH_ADDRESS");
    },
    async navigateToConfirmation() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Create order...",
          html: "this will only take a moment...",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        if (this.intentSecret === null) {
          await this.$store.dispatch(
            "order/CREATE_ORDER",
            this.userAddress.addressId
          );
        }
        await this.payWithCard(this.card, this.stripe);
        this.evtOrderComplete();
        this.$store.commit("product/emptyBasket", null);
        this.$router.push({ name: "Confirmation" });
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Order has been created",
          icon: "info"
        });
      }
    },
    payWithCard: async function(card, stripe) {
      let vm = this;
      await stripe
        .confirmCardPayment(this.intentSecret, {
          payment_method: {
            card: card
          }
        })
        .then(function(result) {
          if (result.error) {
            vm.$swal.close();
            vm.showError(result.error.message);
            vm.$swal({
              title: "Payment Unsuccessfull",
              html: result.error.message,
              icon: "error"
            });
            throw new Error(result.error.message);
          } else {
            vm.$store.commit("order/SET_INTENT_SECRET", null);
          }
        });
    },
    // Show the customer the error from Stripe if their card fails to charge
    showError: function(errorMsgText) {
      var errorMsg = document.querySelector("#card-error");
      errorMsg.textContent = errorMsgText;
      setTimeout(function() {
        errorMsg.textContent = "";
      }, 4000);
    }
  }
};
</script>
<style lang="scss" src="./Checkout.scss"></style>
<style lang="scss">
.checkout {
  .v-input {
    .v-label,
    input {
      font-size: 14px;
    }
  }
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 38px;
  }
}
.hidden {
  display: none;
}
</style>
